import { SxProps, Theme } from '@mui/material';

export const ProductCustomizationTextSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	fontWeight: 'normal',
};

export const ProductCustomizationIconSx: SxProps<Theme> = {
	fontSize: 'var(--font-size-sm)',
	fontWeight: '600',
};
